import { LILAC_400, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPackInfoStyles = isSmallScreen => {
  var spacingToken = tokens.spacing;
  return StyleSheet.create({
    packDetailContainer: {
      flex: 1
    },
    subtitleHeading: {
      marginBottom: spacingToken.SPACING_4
    },
    packDetailsTitle: {
      marginBottom: spacingToken.SPACING_4
    },
    benefitsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: isSmallScreen ? spacingToken.SPACING_12 : spacingToken.SPACING_16
    },
    hiddenBenefitsCountContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: LILAC_400,
      padding: spacingToken.SPACING_7,
      borderRadius: spacingToken.SPACING_4,
      overflow: 'hidden'
    },
    benefitsImages: {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4,
      marginRight: spacingToken.SPACING_8
    }
  });
};